module.exports = __webpack_public_path__ + "static/media/YM46_3.697a332b.jpg";